import React, { useState, useEffect } from "react";
import styled, { useTheme } from "styled-components";
import Desktop from "./Desktop";
import Tablet from "./Tablet";
import Mobile from "./Mobile";
import useWindow from "../useWindow";

const copy = {
  section1: {
    header: "instagram",
    subheader:
      "join me in my chubby art community! stay updated on my current art projects, store updates, and peeks into my personal life.",
  },
  section2: {
    header: "etsy",
    subheader:
      "purchase my cozy art from my shop! stickers, art prints, digital wallpapers, and more!",
  },
  section3: {
    header: "dribbble",
    subheader:
      "welcome to my art collection - featuring my digital illustrations, blender models, graphic designs, and more!",
  },
};

export const Home = () => {
  const { colors } = useTheme();
  const [isScrolling, setIsScrolling] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      if (window.pageYOffset) {
        setIsScrolling(true);
      } else {
        setIsScrolling(false);
      }
    };
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const { serverSide, isDesktop, isTablet, isMobile } = useWindow();

  return (
    <>
      {(serverSide || isDesktop) && <Desktop copy={copy} />}
      {(serverSide || isTablet) && <Tablet copy={copy} />}
      {(serverSide || isMobile) && <Mobile copy={copy} />}
    </>
  );
};
